export interface SurveyAnswerRequest {
    userId: string;
    answers: SurveyAnswer[]
}

export interface SurveyAnswer {
    id: string;
    projectId: string;
    surveyId: string;
    questionId: string;
    sessionId: string;
    userId: string;
    type: 'choice';
    properties: { choice: string; }
    createdAt: Date;
    updatedAt: Date;
}

export const emptySurveyAnswer: SurveyAnswer = {
    id: "",
    projectId: "",
    surveyId: "",
    questionId: "",
    sessionId: "",
    userId: "",
    type: "choice",
    properties: {
        choice: '',
    },
    createdAt: new Date(),
    updatedAt: new Date()
}